<template>
  <v-app>
    <v-toolbar v-show="showTopBar" height="32" flat color="primary" class="fixed-top" ref="topBar">

      <v-btn icon color="white" href="https://goo.gl/maps/7kDn56KkE7QrhSWYA" target="_blank" title="Ver en Mapa">
        <v-icon size="x-small">mdi-map-marker</v-icon>
      </v-btn>
      <span v-show="isDesktop" class="text-caption mr-4 font-weight-medium">Carrera 3 # 3 - 11 Centro, Piso 2 • Gachancipá</span>

      <v-btn icon color="white" href="mailto:contacto@leoncasallas.com" target="_blank" title="Correo Electrónico">
        <v-icon size="x-small">mdi-email</v-icon>
      </v-btn>
      <v-btn icon color="white" href="tel:+573112160295" target="_blank" title="Llamar">
        <v-icon size="x-small">mdi-phone</v-icon>
      </v-btn>
      <span v-show="isDesktop" class="text-caption font-weight-medium">+57 311 216 0295</span>

      <v-spacer></v-spacer>
      <v-btn icon color="white" href="https://wa.me/573112160295" target="_blank" title="WhatsApp">
        <v-icon size="x-small">mdi-whatsapp</v-icon>
      </v-btn> 
      <v-btn icon color="white" href="https://www.facebook.com/leoncasallas" target="_blank" title="Facebook">
        <v-icon size="x-small">mdi-facebook</v-icon>
      </v-btn>
      <v-btn icon color="white" href="https://twitter.com/leoncasallas" target="_blank" title="Twitter">
        <v-icon size="x-small">mdi-twitter</v-icon>
      </v-btn>
    </v-toolbar>

    <v-app-bar app color="white" style="top: 32px;"
      class="fixed-top"
      :class="{ 'second-bar-hidden-top': !showTopBar }">
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title class="logo-container" @click="$router.push('/')" style="cursor: pointer;">
        <v-img
          :src="require('@/assets/landscape-logo.png')"
          class="logo"
        ></v-img>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn v-for="(item, index) in menuItems"
        v-show="isDesktop" 
        :key="index" 
        :to="item.to"
        :color="isActiveRoute(item.to) ? 'primary' : ''"
        >{{ item.title }}</v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app disable-resize-watcher 
      :style="{ paddingTop: showTopBar ? `${topBarHeight}px` : '0' }">
      <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" @click="drawer = false" :to="item.to">
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer class="bg-primary py-10 text-white">
      <v-container>
        <v-row class="mb-6">
          <v-col cols="12" md="8" class="text-center text-md-left mb-6 mb-md-0">
            <div class="font-weight-black text-h6 mb-1">León & Casallas</div>
            <div class="text-caption text-grey-lighten-2 mb-3">
              Gestores & Consultores Inmobiliarios en el norte de Cundinamarca
            </div>
            <div class="text-caption text-grey-lighten-2">
              Especialistas en venta, arriendo, estudio de títulos y seguridad jurídica para su patrimonio inmobiliario.
            </div>
          </v-col>

          <v-col cols="12" md="4" class="text-center text-md-right">
            <div class="font-weight-bold text-subtitle-2 mb-2 text-uppercase tracking-wider">
              Navegación Rápida
            </div>
            <div class="d-flex flex-column gap-1">
              <router-link to="/" class="text-caption text-white text-decoration-none">Inicio</router-link>
              <router-link v-if="$store.getters.isPropertiesSearchEnabled" to="/properties" class="text-caption text-white text-decoration-none">Inmuebles</router-link>
              <router-link to="/about" class="text-caption text-white text-decoration-none">Nosotros</router-link>
            </div>
          </v-col>
        </v-row>

        <v-divider class="border-opacity-25 mb-6"></v-divider>

        <div class="d-flex flex-column flex-md-row align-center justify-space-between text-center text-md-left text-caption text-grey-lighten-2">
          <div>Copyright © 2009 – 2026 León & Casallas. Todos los derechos reservados.</div>
          <div class="mt-2 mt-md-0">Finca Raíz en el norte de Cundinamarca</div>
        </div>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { useDisplay } from 'vuetify'

export default {
  name: 'App',
  data() {
    return {
      showTopBar: true,
      drawer: false,
      display: useDisplay(),
      topBarHeight: 0,
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 0) {
        this.showTopBar = false;
      } else {
        this.showTopBar = true;
      }
    },
    isActiveRoute(route) {
      return this.$route.path === route
    }
  },
  computed: {
    isMobile() {
      return this.display.mobile;
    },
    isDesktop() {
      return !this.display.mobile;
    },
    menuItems() {
      const items = [
        { title: 'Inicio', to: '/' }
      ];
      if (this.$store.getters.isPropertiesSearchEnabled) {
        items.push({ title: 'Inmuebles', to: '/properties' });
      }
      items.push({ title: 'Nosotros', to: '/about' });
      return items;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.topBarHeight = this.$refs.topBar.height;
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
  .logo {
    width: 250px;
    height: auto;
    object-fit: contain;
  }
  .logo-container {
    min-width: 250px;
  }
  .fixed-top {
    transition: top 0.3s ease;
  }
  .second-bar-hidden-top {
    top: 0 !important;
  }
</style>
